import PageLabelBar from "../../components/common/PageLabelBar/PageLabelBar";

export default function Dashboard() {
    return (
        <div className="content">
            <PageLabelBar title="Dashboard" />
        </div>
    );
}